if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);

            // Inicializar precio y cantidad en el modal
            setTimeout(() => this.initQuickAdd(), 800);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      initQuickAdd() {
        const modal = this.modalContent;
        const customInput = modal.querySelector('.qty-input');
        const plus = modal.querySelector('.qty-btn.plus');
        const minus = modal.querySelector('.qty-btn.minus');
        const quantityInput = modal.querySelector('quantity-input input[name="quantity"]');

        if (!customInput || !plus || !minus) return;

        const minQty = parseInt(customInput.dataset.min) || 1;

        function leerPrecio() {
          const el = modal.querySelector('.price-item--regular');
          if (!el) return null;
          const texto = el.textContent.trim();
          if (!texto) return null;
          const num = parseFloat(texto.replace(/[^0-9.]/g, ''));
          return isNaN(num) || num === 0 ? null : num;
        }

        function mostrarPrecios(qty) {
          const unitPrice = leerPrecio();
          if (!unitPrice) return;
          const unitEl = modal.querySelector('#rp-unit-price');
          const totalEl = modal.querySelector('#rp-total-price');
          if (unitEl) unitEl.textContent = '$' + unitPrice.toFixed(2) + ' USD';
          if (totalEl) totalEl.textContent = '$' + (unitPrice * qty).toFixed(2) + ' USD';
        }

        function actualizarProgreso(qty) {
          const select = modal.querySelector('variant-selects select[name="options[Cantidad]"]');
          if (!select) return;

          const options = Array.from(select.querySelectorAll('option'));
          let indiceActual = -1;

          for (let i = 0; i < options.length; i++) {
            const numeros = options[i].value.match(/\d+/g);
            if (!numeros) continue;
            const min = parseInt(numeros[0]);
            const max = parseInt(numeros[1]);
            if (qty >= min && qty <= max) {
              indiceActual = i;
              break;
            }
          }

          const msg = modal.querySelector('#rp-progreso-msg');
          const ahorroMsg = modal.querySelector('#rp-ahorro-msg');
          if (indiceActual === -1 || !msg || !ahorroMsg) return;

          const siguienteOpcion = options[indiceActual + 1];
          if (siguienteOpcion) {
            const numerosSiguiente = siguienteOpcion.value.match(/\d+/g);
            const minSiguiente = parseInt(numerosSiguiente[0]);
            const faltan = minSiguiente - qty;
            msg.textContent = '🛒 Agrega ' + faltan + ' und. más y obten un mejor precio';
            ahorroMsg.textContent = 'Siguiente precio: ' + siguienteOpcion.text;
          } else {
            msg.textContent = '🏆 ¡Estás en el mejor precio disponible!';
            ahorroMsg.textContent = '¡Máximo ahorro alcanzado!';
          }
        }

        function actualizarVariante(cantidad) {
          const select = modal.querySelector('variant-selects select[name="options[Cantidad]"]');
          if (!select) return;
          const options = select.querySelectorAll('option');
          for (let option of options) {
            const numeros = option.value.match(/\d+/g);
            if (!numeros) continue;
            const min = parseInt(numeros[0]);
            const max = parseInt(numeros[1]);
            if (cantidad >= min && cantidad <= max) {
              if (select.value !== option.value) {
                select.value = option.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }
              break;
            }
          }
        }

        function actualizarTodo(val) {
          if (val < minQty) val = minQty;
          customInput.value = val;
          if (quantityInput) {
            quantityInput.value = val;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          actualizarVariante(val);
          setTimeout(() => {
            mostrarPrecios(val);
            actualizarProgreso(val);
          }, 600);
        }

        plus.addEventListener('click', () => {
          actualizarTodo(parseInt(customInput.value) + 1);
        });

        minus.addEventListener('click', () => {
          const current = parseInt(customInput.value);
          if (current > minQty) actualizarTodo(current - 1);
        });

        customInput.addEventListener('blur', () => {
          let val = parseInt(customInput.value);
          if (isNaN(val) || val < minQty) val = minQty;
          actualizarTodo(val);
        });

        // Escuchar cambio de accesorio dentro del modal
        modal.addEventListener('change', (e) => {
          if (e.target.closest('variant-selects')) {
            setTimeout(() => {
              const qty = parseInt(customInput.value) || minQty;
              mostrarPrecios(qty);
              actualizarProgreso(qty);
            }, 600);
          }
        });

        // Inicializar con cantidad mínima
        actualizarTodo(minQty);
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}